import request from "./request";

const Composicao = {
  consultar: criterio =>
    request.get("/composicoes", {
      params: {
        nome: criterio.nome,
        tipo: criterio.tipo,
        page: criterio.pagina,
        limit: criterio.limite
      }
    }),
  cadastrarComposicao: composicao => request.post("/composicoes", composicao),
  alterarComposicao: composicao => request.put("/composicoes", composicao),
  excluirComposicao: id => request.del(`/composicoes`, { params: { id } }),
  buscarComposicao: id => request.get(`/composicoes/${id}`)
};

export default Composicao;



// WEBPACK FOOTER //
// ./src/services/composicao.js